import Component from "../classes/Component"
import { app } from '../utils/store'

import each from 'lodash/each'

import imagesLoaded from 'imagesloaded'

import gsap from 'gsap'


export default class Preloader extends Component {
    constructor() {
        super({
            element: '[data-preloader]',
            elements: {
                page: document.querySelector('[data-app-page]'),
                images: document.querySelectorAll('img'),
                percentage: '.number--percentage',
                progress: 'div.progress',
            }
        })


        app.html.classList.add('loading')
        
        // if(!sessionStorage.getItem('init')){
            // sessionStorage.setItem('init', true)
            
            this.percent = 1

            app.loader = this.element
            this.length = 0
    
            this.imgLoader = new imagesLoaded(this.elements.images)
            this.images = new Array()
            
            this.imgLoader.on('progress',( instance, entry, index ) => {
                // console.log(instance, entry, index)
                var status = entry.isLoaded ? 202 : 404
                if(status === 202){ 
                    this.images.push(entry)
                    this.onAssetLoaded(entry.img)
                    // entry.img.src = app.webp ? entry.img.getAttribute('data-webp') : entry.img.getAttribute('data-src')
                } else if(status === 404){
                    console.warn(status, entry.img.src)
                    delete this.elements.images[index]
                }
            })

            this.imgLoader.on('always',( instance ) => {
                console.log('Done', instance)
                this.percent = 1
                this.onLoaded()
            })
    
            this.createLoader()
        // } else {
            // this.emit('completed')
        // }
    }

    animateIn(){}

    createLoader() {
        if(this.elements.images == 'undefined' || this.elements.images == null || this.elements.images.length == 0){
            gsap.to(this.element, {
                delay: .05,
                duration: 1.5,
                overwrite: true,
                // backgroundColor: 'white',
                onUpdate: () => {
                    this.elements.percentage.innerHTML = `${Math.round(this.percent * 100)}%`
                },
                onComplete: () => { this.onLoaded() }
            })
        }
    }

    onAssetLoaded = (image) => {
        this.length += 1

        // image.setAttribute('loaded','')
        
        this.percent = this.length / this.elements.images.length

        if(this.element){
            gsap.to(this.element, {
                delay: .05,
                duration: 2.5,
                overwrite: true,
                // backgroundColor: 'white',
                onUpdate: () => { 
                    gsap.to(this.elements.progress, {
                        '--progress': `${Math.round(this.percent * 100)}%`,
                    })
                    // this.elements.progress.style.setProperty('--progress', `${Math.round(percent * 100)}%`)
                }
            });
            
            this.elements.percentage.innerHTML = `${Math.round(this.percent * 100)}%`
        }
        
        if(this.percent === 1){ this.onLoaded() }
    }

    onLoaded = () => {
        return new Promise(resolve => {
            this.animateOut = gsap.timeline()

            // this.animateOut
            //     .to(this.elements.percentage, {
            //         autoAlpha: 0,
            //         duration: 1,
            //         y: -50
            //     },0)
            //     .to(this.elements.text, {
            //         autoAlpha: 0,
            //     },0)
            //     .fromTo(app.viewport, {
            //         autoAlpha: .25,
            //         y: window.innerHeight / 1.25
            //     },{
            //         duration: 1.5,
            //         autoAlpha: 1,
            //         y: 0,
            //         clearProps: true,
            //         ease: 'expo.out',
            //     },.05)
            //     .to(this.element, {
            //         duration: 1.5,
            //         // yPercent: -100,
            //         clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
            //         ease: 'expo.out',
            //     },.05)

            
            this.animateOut.call(() => {
                this.emit('completed')
                resolve()
            })
        })
    }

    destroy = () => {
        if(this.element){ 
            gsap.to(this.element, {
                delay: 1,
                autoAlpha: 0,
                onComplete: () => { app.root.removeChild(this.element) }
            })
        }
    }
}
